import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { joinCommunity } from 'modules/community/community.actions';
import { setCommunity } from 'modules/auth/auth.actions';
import {
  View,
  Row,
  Image,
  BodyText,
  Title,
  LinkFont,
  Box,
  Pressable,
} from 'modules/styled';

class CommunityAdminList extends Component {
  static propTypes = {
    community: PropTypes.object,
    actions: PropTypes.object,
    auth: PropTypes.object,
    hashtags: PropTypes.bool,
    p: PropTypes.number,
  };

  handleJoinCommunity = (e, community) => {
    const { auth } = this.props;
    if (auth.isAuthenticated) {
      this.props.actions.joinCommunity(community);
    }
  };

  renderJoinLink = (c) => (
    <LinkFont
      sx={{ color: 'blue' }}
      onPress={(e) => this.handleJoinCommunity(e, c)}
      onClick={(e) => this.handleJoinCommunity(e, c)}
    >
      Join Community
    </LinkFont>
  );

  renderInnerText = (c) => {
    const { hashtags } = this.props;
    return hashtags ? (
      <BodyText sx={{ mt: 4.01 }}>{c.topics.map((t) => '#' + t).join(', ')}</BodyText>
    ) : (
      <Box>
        <BodyText sx={{ mt: 4.01 }}>{c.description}</BodyText>
        <LinkFont sx={{ color: 'black', mt: 4.01 }}>
          {c.memberCount} member{c.memberCount > 1 ? 's' : ''}
        </LinkFont>
      </Box>
    );
  };

  render() {
    const {
      community: { communities },
      actions,
      p,
    } = this.props;
    const hP = typeof p !== 'undefined' ? p : 4;
    return (
      <View>
        {Object.values(communities).map((c) => {
          const communityURl = `/${c.slug}/top`;
          return (
            <Pressable
              to={communityURl}
              onPress={() => actions.setCommunity(c.slug)}
              onClick={() => actions.setCommunity(c.slug)}
              key={c._id}
              bgHover={'lightGreyBg'}
              sx={{
                flex: 1,
                flexDirection: 'column',
              }}
            >
              <Row sx={{ alignItems: 'flex-start', py: 2, px: hP }}>
                <Image
                  source={{ uri: c.image }}
                  sx={{ height: 8, width: 8, mr: 2, bg: 'lightGrey' }}
                />
                <View sx={{ flex: 1 }}>
                  <Title>{c.name} </Title>
                  <View sx={{ flexWrap: 'wrap' }}>{this.renderInnerText(c)}</View>
                </View>
                <Box sx={{ mt: 6 }} />
              </Row>
            </Pressable>
          );
        })}
      </View>
    );
  }
}

const mapStateToProps = (state) => ({
  routing: state.routing,
  community: state.community,
  auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      joinCommunity,
      setCommunity,
    },
    dispatch
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(CommunityAdminList);
